import React from 'react';
import {connect} from 'react-redux';

const resourceViewSwitchSection = ({section, formProxy}, ViewSwitchSection) => {

    const mapStateToProps = (state) => {
        return {
            switchValue: section.viewSwitch(formProxy)
        }
    };

    return connect(mapStateToProps, null)(ViewSwitchSection);
};

export default resourceViewSwitchSection;


// WEBPACK FOOTER //
// ./public/hoc/ResourceViewSwitchSection.jsx